export default {"src":"/_next/static/media/automation-of-repetitive-tasks.0491e301.svg","height":75,"width":90,"blurWidth":0,"blurHeight":0};